import config from "config";

interface ParseMetaDataProps {
  lines: string[];
  metadataIndices: number[];
}

export type PodcastMarkdownConfig = {
  title: string;
  description: string;
  CID: string;
  created?: string;
  length: string;
  tags?: string;
  important_details?: string;
  host?: string;
};

export const parseMarkdown = (contents: string) => {
  const obj: PodcastMarkdownConfig = { title: "", description: "", created: "", CID: "", length: "", tags: "", important_details: "" };
  const getMetadataIndices = (acc: number[], elem: string, i: number, array: string[]) => {
    if (config?.markdownIdentifier.test(elem)) {
      acc.push(i);
    }
    return acc;
  };
  const parseMetadata = ({ lines, metadataIndices }: ParseMetaDataProps) => {
    if (metadataIndices.length > 0) {
      const metadata = lines.slice(metadataIndices[0] + 1, metadataIndices[1]);
      metadata.forEach(line => {
        obj[line.split(": ")[0] as keyof PodcastMarkdownConfig] = line.split(": ")[1];
      });
    }
    return obj;
  };
  const lines = contents.split("\n");
  const metadataIndices = lines.reduce<number[]>(getMetadataIndices, []);
  const metadata = parseMetadata({ lines, metadataIndices });
  return metadata;
};

export const secondsToHms = (length: string) => {
  const secs = Number(length) / 1000;
  const hours = Math.floor(secs / (60 * 60));

  const divisorForMinutes = secs % (60 * 60);
  const minutes = Math.floor(divisorForMinutes / 60);

  const divisorForSeconds = divisorForMinutes % 60;
  const seconds = Math.floor(divisorForSeconds);
  if (hours) {
    return `${hours}:${minutes}:${seconds}`;
  } else if (minutes) {
    return minutes > 10 ? `${minutes}:${seconds}` : `0${minutes}:${seconds}`;
  } else {
    return seconds > 10 ? `00:${seconds}` : `00:0${seconds}`;
  }
};
